// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PaymentBatchDetailModel {
    static getAttributeTypeMap() {
        return PaymentBatchDetailModel.attributeTypeMap;
    }
}
PaymentBatchDetailModel.discriminator = undefined;
PaymentBatchDetailModel.additionalProperties = false;
PaymentBatchDetailModel.attributeTypeMap = [
    {
        "name": "paymentBatchDetailId",
        "baseName": "paymentBatchDetailId",
        "type": "number"
    },
    {
        "name": "claimIds",
        "baseName": "claimIds",
        "type": ""
    },
    {
        "name": "claimGroupId",
        "baseName": "claimGroupId",
        "type": "number"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "expectedAmount",
        "baseName": "expectedAmount",
        "type": "number"
    },
    {
        "name": "actualAmount",
        "baseName": "actualAmount",
        "type": "number"
    },
    {
        "name": "paymentBatchDetailStatus",
        "baseName": "paymentBatchDetailStatus",
        "type": "string"
    },
    {
        "name": "paymentBatchDetailStatusId",
        "baseName": "paymentBatchDetailStatusId",
        "type": "number"
    },
    {
        "name": "externalReferences",
        "baseName": "externalReferences",
        "type": ""
    },
    {
        "name": "checkNumber",
        "baseName": "checkNumber",
        "type": "string"
    },
    {
        "name": "errorMessage",
        "baseName": "errorMessage",
        "type": "string"
    },
    {
        "name": "transactions",
        "baseName": "transactions",
        "type": ""
    },
];
//# sourceMappingURL=paymentBatchDetailModel.js.map